<template>
    <div class="autocomplete">
        <input
            ref="text"
            v-click-outside="{exclude: ['dropdown'], handler: 'deactivate'}"
            v-validate="'required'"
            v-m-android-focus
            :class="{focus: dropdownVisibility}"
            :data-vv-name="id"
            :placeholder="placeholder"
            :value="displayValue"
            autocorrect="off"
            type="text"
            :data-vv-scope="dataVvScope"
            @focus="activate"
            @input="input"
            @keyup.down="pointNextItem"
            @keyup.up="pointPrevItem"
            @keyup.enter="applyItem"
            @keydown.tab="applyItem">
        <ul ref="dropdown">
            <li
                v-for="(item, i) of results"
                :key="i"
                :class="{'selected': pointed_item_index == i}"
                @click="applyItem"
                @mouseover="pointItem(i)">
                {{ item[fieldToShow] }}
            </li>
        </ul>
        <span class="error-message">{{ errors.first(`${dataVvScope}.${id}`) }}</span>
    </div>
</template>

<script>
  import axios from "axios"

  const CancelToken = axios.CancelToken
  let cancel

  export default {
    inject: ['$validator'],
    props: ['id', 'value', 'placeholder', 'url', 'limit', 'dataVvScope', 'fieldToShow'],
    data() {
      return {
        active: false,
        term: '',
        pointed_item_index: 0,
        results: []
      }
    },
    computed: {
      displayValue: function () {
        return this.active ? this.term : this.value[this.fieldToShow]
      },
      dropdownVisibility: function () {
        return this.active && !!this.results.length
      }
    },
    methods: {
      activate() {
        this.active = true
        this.pointed_item_index = -1
        this.term = this.value[this.fieldToShow]
        this.results = []
      },
      deactivate() {
        // && document.activeElement != this.$refs.text
        if(this.active){
          this.$nextTick(function(){
            this.$validator.validate(`${this.dataVvScope}.${this.id}`)
          })
          this.active = false
          this.$refs.text.blur()
        }
      },
      input() {
        this.term = this.$refs.text.value
        console.log(this.term)

        if (this.term) {

          if (cancel !== undefined) { cancel() }
          // req = $.get('https://api-macda.flyforsinkelse.dk/v2/airports', { term: term, search_v2: true, per_page: 10 }, function(data) {
          axios.get(
            "https://api-macda.flyforsinkelse.dk/v2/airports",
            // this.url + ".json?term=" + this.term + "&limit=" + this.limit,
            {
              params: {
                term: this.term,
                search_v2: true,
                per_page: this.limit || 10
              },
              cancelToken: new CancelToken(function executor(c){
                  cancel = c
              })
            }
          )
          .then((response) => {
            this.results = response.data
            this.pointed_item_index = -1
          })
          .catch(() => {})
        } else {
          this.results = []
        }
      },
      pointNextItem() {
        (this.results.length-1) > this.pointed_item_index ? this.pointed_item_index++ : null
      },
      pointPrevItem() {
        this.pointed_item_index > 0 ? this.pointed_item_index-- : null
      },
      pointItem(i) {
        this.pointed_item_index = i
      },
      applyItem() {
        let item = this.results[this.pointed_item_index]
        if (item) {
          this.term = item[this.fieldToShow]
          this.$emit("input", item)
        }
        this.deactivate()
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~@stylesheets/_vars.scss';

  .autocomplete {
    position: relative;

    input {
      &.focus {
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
        border-bottom: none;
      }
    }

    input.focus + ul {
      display: block;
    }

    ul {
      display: none;
      margin: 0;
      padding: 0;
      z-index: 2;
      width: 100%;
      list-style: none;
      border-top: none;
      position: absolute;
      background: white;
      box-sizing: border-box;
      border: 1px solid $light_gray_a;
      border-bottom-right-radius: 3px;
      border-bottom-left-radius: 3px;
      -webkit-box-shadow: 0 3px 5px 1px lightgrey;
      box-shadow: 0 3px 5px 1px lightgrey;

      li {
        cursor: pointer;
        padding: 10px 10px 10px 20px;
        border: 1px solid $light_gray_a;

        html.mobile & {
          padding: 5px 5px 5px 10px;
          font-size: 14px;
        }

        &.selected {
          background-color: $light_gray_a;
        }
      }
    }
  }
</style>
